<template>
  <!-- 1.all-container-start -->
  <div class="all-container">
    <!-- 财务中心->每月对账单 -->
    <div class="main2">
      <div class="title">每月对账单</div>
      <div v-if="!isShow" class="main2">
        <div class="search">
          <el-form :model="queryParams" ref="queryForm" :inline="true">
            <el-form-item label="每月对账" prop="beginTime">
              <el-date-picker
                clearable
                size="small"
                style="width: 200px"
                v-model="queryParams.beginTime"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="开始时间"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item label="—" prop="endTime" class="df-sjkjs">
              <el-date-picker
                clearable
                size="small"
                style="width: 200px"
                v-model="queryParams.endTime"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="截止时间"
              >
              </el-date-picker>
            </el-form-item>

            <el-form-item>
              <el-button
                icon="el-icon-search"
                size="small"
                style="border-color:#97c5e9;font-size:14px;border-radius:0;padding:7px 20px 8px;"
                @click="search"
                >搜索</el-button
              >
            </el-form-item>
          </el-form>
        </div>
        <el-table
          :data="aryList"
          style="width: 100%;border-left:1px solid #e7e6e4;border-right:1px solid #e7e6e4"
          :cell-style="{
            'text-align': 'center',
            'border-color': '#dbdbdb',
            position: 'relative',
            'background-color': '#fff',
            'border-right': '1px solid #e7e6e4',
          }"
          :header-cell-style="{
            'background-color': '#e7e6e4',
            color: '#000',
            fontSize: '14px',
            fontWeight: '300',
            'text-align': 'center',
            padding: '5px 0',
          }"
        >
          <el-table-column prop="num" align="center" label="序号" width="65">
            <template slot-scope="scope">
              {{ (pageNum - 1) * 10 + (scope.$index + 1) }}
            </template>
          </el-table-column>
          <el-table-column prop="statmentName" label="账单" min-width="180">
            <template slot-scope="scope">
              {{ scope.row.statmentName }}
            </template>
          </el-table-column>

          <el-table-column prop="deductionMoney" label="充值" min-width="120">
            <template slot-scope="scope">
              {{ to_f(scope.row.deductionMoney || "0.00") }}
            </template>
          </el-table-column>

          <el-table-column prop="rechargeMoney" label="扣款" min-width="120">
            <template slot-scope="scope">
              {{ to_f(scope.row.rechargeMoney || "0.00") }}
            </template>
          </el-table-column>

          <el-table-column prop="balance" label="余额" min-width="120">
            <template slot-scope="scope">
              {{ to_f(scope.row.balance || "0.00") }}
            </template>
          </el-table-column>

          <el-table-column
            prop="goodsTotalMoney"
            label="商品总额"
            min-width="120"
          >
            <template slot-scope="scope">
              {{ to_f(scope.row.goodsTotalMoney || "0.00") }}
            </template>
          </el-table-column>

          <el-table-column prop="freights" label="运费总额" min-width="120">
            <template slot-scope="scope">
              {{ to_f(scope.row.freights || "0.00") }}
            </template>
          </el-table-column>

          <el-table-column prop="freights" label="操作">
            <template slot-scope="scope">
              <el-button
                size="mini"
                style="border-color:#97c5e9;font-size:14px;border-radius:0;"
                @click="watchOrderDetail(scope.row)"
                >查看</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <br />

        <el-pagination
          v-if="totalPages > 0"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageNum"
          :page-sizes="[10, 20, 30, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
        <el-button size="mini" style="display:inline-block;">GO</el-button>
      </div>
      <div v-if="isShow" class="main borderShadow"></div>
    </div>
    <!-- 财务中心->每月对账单 -->
  </div>
  <!-- 1.all-container-end -->
</template>

<script>
import { everyMonthRecordRequest } from "../../../public/js/service";

export default {
  data() {
    // 1.data
    return {
      totalPages: 1, //总页码,
      pageNum: 1, //当前页码
      total: 1, //总条数
      pageSize: 10, //每页条数
      aryList: [], // 数据列表
      token: "", //token
      isShow: false,
      queryParams: {
        orderNum: null,
        beginTime: null,
        endTime: null,
      },
    };
  },

  components: {},

  methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.pageNum = val;
      this.getList();
    },

    getList() {
      // 3.4.getList
      let data = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        params: {
          beginTime: this.queryParams.beginTime,
          endTime: this.queryParams.endTime,
        },
      };

      everyMonthRecordRequest(data).then((res) => {
        if (res) {
          this.total = res.totals || 1;
          this.totalPages = Math.ceil(res.totals / this.pageSize) || 1;
          this.aryList = res.data;
        }
      });
    },

    watchOrderDetail(item) {
      // 3.5.查看每月对账单详情
      console.log(item);
      this.$router.push(
        "/everyOrderDetail?obj=" + encodeURIComponent(JSON.stringify(item))
      );
    },
    search() {
      this.pageNum = 1;
      this.getList();
    },
  },

  mounted() {
    // 4.4.mounted
    if (localStorage.token) {
      // 4.4.1.修改密码需要token
      this.token = localStorage.token;
      this.getList();
    }
  },
};
</script>
